const bundleProductsContainerDesktop = document.querySelector('.bundle-section__atc-box__line-items-desktop');
const bundleProductsContainerMobile = document.querySelector('.bundle-section__atc-box__line-items-mobile');

const buttons = document.querySelectorAll('.atc-button');
const atbButtons = document.querySelectorAll('.atb-button')
const atcButton = document.querySelector('#AtcButton');
const bundleProgressBar = document.querySelector('.bundle-progress-bar-empty');
const progressBarIcon = bundleProgressBar.querySelector('.bundle-progress-bar-icon');
const submitForm = document.querySelector('form.bundle-form');
const searchBar = document.querySelector('#BundleSearch');
const productCards = Array.from(document.querySelectorAll('.bundle-product-card'));
const emptyState = document.querySelector(".empty-state");
const productList = document.querySelector(".product-list");
const filterButtons = document.querySelectorAll('.bundle-section__filter-button');
const bundleDiscount = document.querySelector('#bundle-discount').innerHTML.trim();
const atcBoxTotal = document.querySelector('.bundle-section__atc-box__total');
const basketItemPrice = document.querySelectorAll('.basket-item-price')
const strikePrice = document.querySelector('#strike-price');
const actualPrice = document.querySelector('#actual-price');
const sparenText = document.querySelector('#sparen');



buttons.forEach((button) => {
    button.addEventListener('click', () => {
        const buttonId = button.dataset.id 
        const currentBasketItems = Array.from(bundleProductsContainerDesktop.querySelectorAll('.line-item'));
        const isAlreadyInBasket = currentBasketItems.some((item) => {
            return  item.dataset.id  === buttonId;
        })
        
        if (isAlreadyInBasket) {
            // Desktop: Quantity erhöhen
            const currentBasketItem = currentBasketItems.find((item) => {
                return item.dataset.id === buttonId
            })
            const currentInputElement = currentBasketItem.querySelector('.quantity-selector__input');
            currentInputElement.value = Number(currentInputElement.value) + 1
            
            // Mobile: Neuen Placeholder füllen (nur wenn noch SVG Placeholder vorhanden)
            addToBasketMobileOnly(button);
            
        } else {
            // Beide: Neues Item hinzufügen
            addToBasket(button)
        }

        checkBasketSize()
    });
});

function addToBasket(button) {
    const currentProductCard = button.closest('.product-card');
    const placeholderDesktop = currentProductCard.querySelector('.bundle-line-item__placeholder');
    const placeholderMobile = currentProductCard.querySelector('.bundle-line-item__placeholder-mobile');
   
    // Desktop Version
    const newBundleProductDesktop = document.createElement('div');
    newBundleProductDesktop.classList = 'new-item-wrapper-desktop'
    newBundleProductDesktop.innerHTML = placeholderDesktop.innerHTML; 

    const size = Array.from(bundleProductsContainerDesktop.querySelectorAll(".line-item")).length;

    newBundleProductDesktop.querySelector('[name="id"]').setAttribute("name", `items[${size}][id]`);
    newBundleProductDesktop.querySelector('[name="quantity"]').setAttribute("name", `items[${size}][quantity]`);
    newBundleProductDesktop.querySelector('[name="properties[Bundle Discount]"]').setAttribute("name", `items[${size}][properties][Bundle Discount]`);

    const inputElementDesktop = newBundleProductDesktop.querySelector('.quantity-selector__input');
    const removeButtonDesktop = newBundleProductDesktop.querySelector('.remove-button');

    const quantityButtons = newBundleProductDesktop.querySelectorAll('.quantity-selector__button');
quantityButtons.forEach(btn => {
    btn.addEventListener('click', () => {
        setTimeout(() => {
            if (Number(inputElementDesktop.value) === 0) {
                newBundleProductDesktop.remove();
                const allMobileItems = Array.from(bundleProductsContainerMobile.querySelectorAll(`.line-item[data-id="${button.dataset.id}"]`));
                allMobileItems.forEach(item => item.remove());
            }
            checkBasketSize();
        }, 0);
    });
});

    // Mobile Version - nur wenn noch Placeholder vorhanden
    const firstPlaceholder = bundleProductsContainerMobile.querySelector('.line-items-mobile__placeholder');
    
    if (firstPlaceholder) {
        const newBundleProductMobile = document.createElement('div');
        newBundleProductMobile.innerHTML = placeholderMobile.innerHTML;
        
        firstPlaceholder.replaceWith(newBundleProductMobile);
        
        newBundleProductMobile.addEventListener('click', () => {
            // Desktop-Item Quantity reduzieren statt entfernen
            const matchingDesktopItem = bundleProductsContainerDesktop.querySelector(`.line-item[data-id="${button.dataset.id}"]`);
            if (matchingDesktopItem) {
                const desktopInput = matchingDesktopItem.querySelector('.quantity-selector__input');
                const currentQty = Number(desktopInput.value);
                
                if (currentQty > 1) {
                    desktopInput.value = currentQty - 1;
                } else {
                    matchingDesktopItem.closest('div').remove();
                }
            }

            // Mobiles Item wieder durch Placeholder ersetzen
            newBundleProductMobile.replaceWith(firstPlaceholder);

            checkBasketSize();

            Array.from(bundleProductsContainerMobile.children).forEach((child) => {
                if (!child.innerHTML.trim()) {
                    child.remove();
                }
            });
        });
    }

    // Event Listeners für Desktop
    removeButtonDesktop.addEventListener('click', () => {
        newBundleProductDesktop.remove();
        // Alle Mobile-Items mit dieser ID entfernen
        const allMobileItems = Array.from(bundleProductsContainerMobile.querySelectorAll(`.line-item[data-id="${button.dataset.id}"]`));
        allMobileItems.forEach(item => item.remove());
        checkBasketSize();
    });

    inputElementDesktop.addEventListener('change', () => {
        if (Number(inputElementDesktop.value) === 0) {
            newBundleProductDesktop.remove();
            // Alle Mobile-Items mit dieser ID entfernen
            const allMobileItems = Array.from(bundleProductsContainerMobile.querySelectorAll(`.line-item[data-id="${button.dataset.id}"]`));
            allMobileItems.forEach(item => item.remove());
        }
        checkBasketSize();
    });

    bundleProductsContainerDesktop.appendChild(newBundleProductDesktop);
}

// Neue Funktion nur für Mobile
function addToBasketMobileOnly(button) {
    // Nur hinzufügen wenn noch ein Placeholder vorhanden ist
    const firstPlaceholder = bundleProductsContainerMobile.querySelector('.line-items-mobile__placeholder');
    
    if (!firstPlaceholder) {
        return; // Kein Placeholder mehr da, nichts tun
    }
    
    const currentProductCard = button.closest('.product-card');
    const placeholderMobile = currentProductCard.querySelector('.bundle-line-item__placeholder-mobile');
   
    // Nur Mobile Version
    const newBundleProductMobile = document.createElement('div');
    newBundleProductMobile.innerHTML = placeholderMobile.innerHTML;

    firstPlaceholder.replaceWith(newBundleProductMobile);
    
    newBundleProductMobile.addEventListener('click', () => {
        // Desktop-Item Quantity reduzieren statt entfernen
        const matchingDesktopItem = bundleProductsContainerDesktop.querySelector(`.line-item[data-id="${button.dataset.id}"]`);
        if (matchingDesktopItem) {
            const desktopInput = matchingDesktopItem.querySelector('.quantity-selector__input');
            const currentQty = Number(desktopInput.value);
            
            if (currentQty > 1) {
                desktopInput.value = currentQty - 1;
            } else {
                matchingDesktopItem.closest('div').remove();
            }
        }

        // Mobiles Item wieder durch Placeholder ersetzen
        newBundleProductMobile.replaceWith(firstPlaceholder);

        checkBasketSize();

        Array.from(bundleProductsContainerMobile.children).forEach((child) => {
            if (!child.innerHTML.trim()) {
                child.remove();
            }
        });
    });
}

function updatePrices() {
    // Alle Line Items durchgehen
    const currentBasketItems = bundleProductsContainerDesktop.querySelectorAll('.line-item');
    
    // Alle Preise mit Quantity multiplizieren und addieren
    let totalStrikePrice = 0;
    currentBasketItems.forEach((item) => {
        const priceElement = item.querySelector('.basket-item-price');
        const quantityInput = item.querySelector('.quantity-selector__input');
        
        if (priceElement && quantityInput) {
            const priceText = priceElement.innerHTML.trim();
            const cleanPrice = priceText.replace('€', '').trim().replace(',', '.');
            const price = parseFloat(cleanPrice);
            const quantity = Number(quantityInput.value);
            
            if (!isNaN(price) && !isNaN(quantity)) {
                totalStrikePrice += (price * quantity);
            }
        }
    });
    
    // Bundle Discount extrahieren
    const discountMatch = bundleDiscount.match(/[\d,\.]+/);
    const discountValue = discountMatch ? parseFloat(discountMatch[0].replace(',', '.')) : 0;
    
    const totalActualPrice = discountValue;
    
    // Preise ausgeben
    if (strikePrice && !isNaN(totalStrikePrice)) {
        strikePrice.innerHTML = '€' + totalStrikePrice.toFixed(2).replace('.', ',');
    }
    if (actualPrice && !isNaN(totalActualPrice)) {
        actualPrice.innerHTML = '€' + totalActualPrice.toFixed(2).replace('.', ',');
    }
}

function checkBasketSize () {
    const basketProductsInputs = Array.from(bundleProductsContainerDesktop.querySelectorAll('.quantity-selector__input'));
    const size = basketProductsInputs.reduce((acc, curr) => acc + Number(curr.value), 0)
    const remaining = 3 - size; 
    const percentage = (size / 3) * 100;

    bundleProgressBar.setAttribute('style', `--progress-width: ${percentage}%`);

    if (percentage >= 100) {
        progressBarIcon.classList.remove('progress--remaining');
        progressBarIcon.classList.add('progress--full');
    } else {
         progressBarIcon.classList.remove('progress--full');
        progressBarIcon.classList.add('progress--remaining');
    }

if (remaining <= 0) {
    atcButton.disabled = false
    atcButton.textContent = `${size} Düfte in den Warenkorb`
    atcBoxTotal.hidden = false

} else {
    atcButton.disabled = true
    atcButton.textContent = `Noch ${remaining} Düfte hinzufügen`
    atcBoxTotal.hidden = true
}

if (remaining === 1) {
    atcButton.disabled = true
    atcButton.textContent = `Noch ${remaining} Duft hinzufügen!`
    atcBoxTotal.hidden = true
}

if (remaining === 0) {
    atbButtons.forEach(button => {
        button.disabled = true
    })
    
    // Alle Quantity Inputs und deren Buttons deaktivieren
    const allQuantitySelectors = bundleProductsContainerDesktop.querySelectorAll('.quantity-selector__input, .quantity-selector__button');
    allQuantitySelectors.forEach(element => {
        element.disabled = true;
    });
} else {
    atbButtons.forEach(button => {
        button.disabled = false
    })
    
    // Alle Quantity Inputs und deren Buttons aktivieren
    const allQuantitySelectors = bundleProductsContainerDesktop.querySelectorAll('.quantity-selector__input, .quantity-selector__button');
    allQuantitySelectors.forEach(element => {
        element.disabled = false;
    });
}
    
    // Preisberechnung aufrufen
    updatePrices();
}

submitForm.addEventListener('submit', (event) => {
    event.preventDefault();

    let itemsArray = [];

    const currentBasketItems = Array.from(bundleProductsContainerDesktop.querySelectorAll('.line-item'));

    const basketProductsInputs = Array.from(bundleProductsContainerDesktop.querySelectorAll('.quantity-selector__input'));
    const size = basketProductsInputs.reduce((acc, curr) => acc + Number(curr.value), 0)

    const uniqueId = new Date().getTime().toString()
    currentBasketItems.forEach((item) => {
        const itemId = item.querySelector('[data-id]').value
        const itemQuantity = item.querySelector('[data-quantity]').value
        const itemProperty = item.querySelector('[data-property]').value

        const itemObject = {
            id: itemId, 
            quantity: itemQuantity,
            properties: {
                "_bundleDiscount": itemProperty, 
                "_uniqueId": uniqueId,
                "_size": size, 
                "_parentId": submitForm.dataset.variantId
            }
        }

        itemsArray.push(itemObject)
    })

    // Collect section IDs the cart drawer needs (same pattern as ProductForm)
    const sectionsToBundle = [];
    document.documentElement.dispatchEvent(
        new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
    );

    const formData = {
        items: itemsArray,
        sections: sectionsToBundle.join(',')
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(res => res.json())
    .then(async (responseJson) => {
      const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
      cartContent['sections'] = responseJson['sections'];

      document.documentElement.dispatchEvent(
          new CustomEvent('cart:change', {
              bubbles: true,
              detail: {
                  baseEvent: 'variant:add',
                  cart: cartContent
              }
          })
      );
    })
    .catch((error) => {
      console.error('Error:', error);
    });
})

searchBar.addEventListener("input", () => {
  applyFilters();
});

filterButtons.forEach((button) => {
  button.addEventListener("click", () => {
    button.classList.toggle("active");
    applyFilters();
  });
});

function applyFilters() {
  // Get all active filter buttons
  const activeFilters = Array.from(filterButtons)
    .filter((button) => button.classList.contains("active"))
    .map((button) => ({
      group: button.dataset.filterGroup,
      value: button.dataset.filterValue,
    }));

  // Group filters by filter group
  const filtersByGroup = {};
  activeFilters.forEach((filter) => {
    if (!filtersByGroup[filter.group]) {
      filtersByGroup[filter.group] = [];
    }
    filtersByGroup[filter.group].push(filter.value);
  });

  // Get all filter groups that have active filters
  const activeFilterGroups = Object.keys(filtersByGroup);
  const searchBarInput = searchBar.value.toLowerCase();

  // Filter product cards
  let visibleCount = 0;
  productCards.forEach((card) => {
    let matchesAllGroups = true;

    // If filters are active, check if card matches all active filter groups (AND logic)
    if (activeFilterGroups.length > 0) {
      for (const filterGroup of activeFilterGroups) {
        const cardFilterAttribute = `data-filter-group-${filterGroup}`;
        const cardFilterValue = card.getAttribute(cardFilterAttribute);

        // If card doesn't have this filter group attribute, it doesn't match
        if (!cardFilterValue) {
          matchesAllGroups = false;
          break;
        }

        // Check if card's value matches any of the selected values in this group (OR logic)
        const selectedValues = filtersByGroup[filterGroup];
        const cardFilterValues = cardFilterValue
          .split(",")
          .map((value) => value.trim())
          .filter((value) => value !== "");

        const hasMatch = cardFilterValues.some((value) =>
          selectedValues.includes(value)
        );

        if (!hasMatch) {
          matchesAllGroups = false;
          break;
        }
      }
    }

    // Check search filter if search bar has value
    const matchesSearch =
      searchBarInput === "" ||
      card.dataset.productTitle.toLowerCase().includes(searchBarInput);

    if (matchesAllGroups && matchesSearch) {
      card.classList.remove("hidden");
      visibleCount++;
    } else {
      card.classList.add("hidden");
    }
  });

  updateEmptyState();
}

function updateEmptyState() {
  const visibleCards = productCards.filter(
    (card) => !card.classList.contains("hidden")
  );

  if (visibleCards.length === 0) {
    emptyState.classList.remove("hidden");
    productList.classList.add("hidden");
  } else {
    emptyState.classList.add("hidden");
    productList.classList.remove("hidden");
  }
}